export enum VideoTypes {
  YOUTUBE,
  SOURCE
}
